import accountService from '@/modules/account/services/accountService'
import {abTestService} from '@/modules/common/services'

const state = {
  loading: true,
  packageAliases: { ultimate: ['ultimate', 'vcita_kickstart'], scheduling: ['scheduling'], online_payments: ['online_payments'], teams_single: ['teams_single', 'teams', 'ts_business'], enterprise_single: ['enterprise_single'], teams: ['teams', 'ts_business'], enterprise: ['enterprise', 'platinum5', 'ts_platinum'], platinum10: ['platinum10'], platinum20: ['platinum20'] },
  page: {
    currency: null,
    country: null,
    displayedPackages: ['ultimate', 'teams', 'teams_single', 'enterprise', 'enterprise_single', 'ts_business', 'ts_platinum', 'platinum5', 'platinum10', 'platinum20'],
    mode: '',
    active: -1,
    paymentMode: 'annually',
    selectedPackage: '',
    activeSubpackage: '',
  },
  displayedData: {},
}

let getPackagesData = (param = false) => {
  return [
    {
      card: {
        name: 'ultimate',
        displayName: 'Kickstart',
        recurlyName: 'vcita_kickstart',
        title: param ? `packages.vcita_kickstart_package.title_${param}` : 'packages.vcita_kickstart_package.title',
        price: {
          mxn: {
            monthly: 700,
            annually: 583,
          },
          gbp: {
            monthly: 28,
            annually: 23,
          },
          usd: {
            monthly: 35,
            annually: 29,
          },
        },
        data: param ? `packages.vcita_kickstart_package.card_data_${param}` : 'packages.vcita_kickstart_package.card_data',
        extraPackage: {
          name: 'scheduling',
          link: 'packages.online_scheduling_package.link',
          header: 'packages.online_scheduling_package.header',
          data: 'packages.online_scheduling_package.data',
          price: {
            usd: 12,
            gbp: 10,
          },
        },
        extraWixPackage: {
          name: 'online_payments',
          link: 'packages.wix_online_payments_package.link',
          header: 'packages.wix_online_payments_package.header',
          data: 'packages.wix_online_payments_package.data',
          price: {
            usd: 8,
            gbp: 6,
          },
        },
      },
      type: 'solo',
      list: {
        name: 'ultimate',
        key: 0,
        type: 'solo',
        header: 'packages.data.includes',
        smsData: {us: 100, other: 20},
        campaignsData: 'packages.vcita_kickstart_package.campaign_recipients',
        setupData: 'packages.vcita_kickstart_package.setup_session',
      },
    },
    {
      card: {
        name: 'teams_single',
        displayName: 'Business',
        recurlyName: 'teams_single',
        bestseller: true,
        title: param ? `packages.business_package.title_${param}` : 'packages.business_package.title',
        price: {
          mxn: {
            monthly: 1300,
            annually: 1083,
          },
          gbp: {
            monthly: 52,
            annually: 43,
          },
          usd: {
            monthly: 65,
            annually: 54,
          },
        },
        subtitle: 'packages.business_package.subtitle',
        data: param ? `packages.business_package.card_data_${param}` : 'packages.business_package.card_data',
      },
      type: 'solo',
      list: {
        name: 'teams',
        key: 1,
        type: 'solo',
        header: 'packages.data.includes',
        smsData: {us: 250, other: 50},
        campaignsData: 'packages.business_package.campaign_recipients',
        setupData: 1,
      },
    },
    {
      card: {
        name: 'enterprise_single',
        displayName: 'Platinum',
        recurlyName: 'platinum',
        title: param ? `packages.platinum_package.title_${param}` : 'packages.platinum_package.title',
        price: {
          mxn: {
            monthly: 2200,
            annually: 1833,
          },
          gbp: {
            monthly: 90,
            annually: 75,
          },
          usd: {
            monthly: 110,
            annually: 93,
          },
        },
        subtitle: 'packages.platinum_package.subtitle',
        data: param ? `packages.platinum_package.card_data_${param}` : 'packages.platinum_package.card_data',
      },
      type: 'solo',
      list: {
        name: 'enterprise',
        key: 2,
        type: 'solo',
        header: 'packages.data.includes',
        smsData: {us: 500, other: 100},
        campaignsData: 'packages.platinum_package.campaign_recipients',
        setupData: 2,
      },
    },

    {
      card: {
        name: 'teams',
        displayName: 'Business',
        recurlyName: 't_business',
        title: param ? `packages.business_teams_package.title_${param}` : 'packages.business_teams_package.title',
        price: {
          mxn: {
            monthly: 1300,
            annually: 1083,
            subpackages: {
              monthly: {
                'team of 5': 1900,
                'team of 10': 3100,
                'team of 20': 5050,
              },
              annually: {
                'team of 5': 1583,
                'team of 10': 2583,
                'team of 20': 4208,
              },
            },
          },
          gbp: {
            monthly: 52,
            annually: 43,
            subpackages: {
              monthly: {
                'team of 5': 75,
                'team of 10': 125,
                'team of 20': 205,
              },
              annually: {
                'team of 5':  63,
                'team of 10': 104,
                'team of 20': 171,
              },
            },
          },
          usd: {
            monthly: 65,
            annually: 54,
            subpackages: {
              monthly: {
                'team of 5': 95,
                'team of 10': 155,
                'team of 20': 255,
              },
              annually: {
                'team of 5': 79,
                'team of 10': 129,
                'team of 20': 213,
              },
            },
          },
        },
        data: param ? `packages.business_teams_package.card_data_${param}` : 'packages.business_teams_package.card_data',
        subpackages:  {
          'team of 5': {
            recurlyName: 'business4',
            packageName: 'business4',
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_five',
            staffMembers: 4,
          },
          'team of 10': {
            recurlyName: 'business10',
            packageName: 'business10',
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_ten',
            staffMembers: 10,
          },
          'team of 20': {
            recurlyName: 'business20',
            packageName: 'business20',
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_twenty',
            staffMembers: 20,
          },
        },
      },
      type: 'team',
      list: {
        type: 'team',
        key: 3,
        name: 'business',
        header: 'packages.business_teams_package.display_name',
        smsData: {
          'team of 5': {us: 500, other: 100},
          'team of 10': {us: 750, other: 150},
          'team of 20': {us: 1000, other: 200},
        },
        campaignsData: {
          'team of 5': '7,500',
          'team of 10': '10,000',
          'team of 20': '12,500',
        },
        support: 'packages.business_teams_package.support',
        customer_success: 'packages.business_teams_package.customer_success',
      },
    },
    {
      card: {
        name: 'enterprise',
        displayName: 'Platinum',
        recurlyName: 't_platinum_4',
        title: param ? `packages.platinum_teams_package.title_${param}` : 'packages.platinum_teams_package.title',
        price: {
          mxn: {
            monthly: 2900,
            annually: 2417,
            subpackages: {
              monthly: {
                'team of 5': 2900,
                'team of 10': 4500,
                'team of 20': 7200,
              },
              annually: {
                'team of 5': 2417,
                'team of 10': 3750,
                'team of 20': 6000,
              },
            },
          },
          gbp: {
            monthly: 120,
            annually: 100,
            subpackages: {
              monthly: {
                'team of 5': 120,
                'team of 10': 180,
                'team of 20': 285,
              },
              annually: {
                'team of 5': 100,
                'team of 10': 150,
                'team of 20': 238,
              },
            },
          },
          usd: {
            monthly: 149,
            annually: 125,
            subpackages: {
              monthly: {
                'team of 5': 149,
                'team of 10': 227,
                'team of 20': 360,
              },
              annually: {
                'team of 5': 125,
                'team of 10': 190,
                'team of 20': 300,
              },
            },
          },
        },
        subtitle: 'packages.platinum_teams_package.subtitle',
        data: param ? `packages.platinum_teams_package.card_data_${param}` : 'packages.platinum_teams_package.card_data',
        subpackages: {
          'team of 5': {
            listName: 'packages.platinum_teams_package.subpackages.list_names.team_five', // PLATINUM 5
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_five', // Team of 5
            teamSize: 'packages.platinum_teams_package.subpackages.card_names.team_five', // 2-5
            recurlyName: 't_platinum_4',
            packageName: 'platinum4',
            staffMembers: 5,
          },
          'team of 10': {
            listName: 'packages.platinum_teams_package.subpackages.list_names.team_ten', // PLATINUM 10
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_ten', // Team of 10
            teamSize: 'packages.platinum_teams_package.subpackages.card_names.team_ten', // 5-10
            recurlyName: 't_platinum_10',
            packageName: 'platinum10',
            staffMembers: 10,
          },
          'team of 20': {
            listName: 'packages.platinum_teams_package.subpackages.list_names.team_twenty', // PLATINUM 20
            switcherName: 'packages.platinum_teams_package.subpackages.card_names.team_twenty', // Team of 20
            teamSize: 'packages.platinum_teams_package.subpackages.card_names.team_twenty', // 10-20
            recurlyName: 't_platinum_20',
            packageName: 'platinum20',
            staffMembers: 20,
          },
        },
      },
      type: 'team',
      list: {
        type: 'team',
        key: 4,
        name: 'platinum',
        header: 'packages.platinum_teams_package.display_name',
        smsData: {
          'team of 5': {us: 750, other: 150},
          'team of 10': {us: 1000, other: 200},
          'team of 20': {us: 1500, other: 300},
        },
        campaignsData: {
          'team of 5': '15,000',
          'team of 10': '20,000',
          'team of 20': '25,000',
        },
        support: 'packages.platinum_teams_package.support',
        customer_success: 'packages.platinum_teams_package.customer_success',
      }
    }
  ]
}

const data = {
  defaultActive: 1,
  defaultActiveTeam: 4,
  defaultSubpackage: 'team of 5',
}





const getters = {
  packageData: state => packageName => {
    return data.packagesData[packageName]
  },
  getDefaultActiveCard: state => {
    return state.page.mode == 'solo' ? data.defaultActive : data.defaultActiveTeam
  },
  loading: state => {
    return state.loading
  },
  page: state => {
    return state.page
  },
  getDefaultActiveSubpackage: state => {
    return data[state.page.mode].defaultSubpackage
  },
  displayedData: state => {
    return state.displayedData
  },
}

const mutations = {
  setLoading(state, value) {
    state.loading = value
  },
  setData(state, data) {
    state.displayedData = data
  },
  setMode(state, value) {
    state.page.mode = value
    state.page.active = state.page.mode == 'solo' ? data.defaultActive : data.defaultActiveTeam
  },
  setPaymentMode(state, value) {
    state.page.paymentMode = value
  },
  setActiveCard(state, cardNum) {
    state.page.active = cardNum
  },
  setActiveSubpackage(state, subpackage) {
    state.page.activeSubpackage = subpackage
  },
  setGeoData(state, geoData) {
    state.page.country = geoData.country
    let country = geoData.country.toLowerCase()
    let continent = geoData.continent.toLowerCase()

    if (country == 'united kingdom')
      state.page.currency = 'gbp'
    else if (country == 'mexico')
      state.page.currency = 'mxn'
    else if (continent == 'europe')
      state.page.currency = 'eur'
    else state.page.currency = 'usd'
  },
}

const actions = {
  async init({ commit, dispatch }) {
    commit('setLoading', true)
    await dispatch('findGeoData')
    await dispatch('setData')
    commit('setMode', 'solo')
    commit('setLoading', false)
  },
  async findGeoData(context){
    if (!context.getters.page.country) {
      let geoData = await accountService.getGeoDataByIP()
      context.commit('setGeoData', geoData)
    }
  },
  async setData(context){
    const business = context.rootGetters['accountModule/business']
    let vertical = (business.locale === 'en' && accountService.checkVerticalExistance(business.vertical_name)) ? business.vertical_name : false
    let data = getPackagesData(vertical)
    context.commit('setData', data)
  },
  async onChangeMode(context, value) {
    if(value == 'team'){
      context.commit('setActiveCard', 3)
    }
    context.commit('setMode', value)
  },
  async onChangePaymentMode(context, value) {
    context.commit('setPaymentMode', value)
  },
  async changeActiveCard(context, cardNum) {
    context.commit('setActiveCard', cardNum)
  },
  async onSubpackageChange(context, subpackage) {
    context.commit('setActiveSubpackage', subpackage)
  }
}



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
